/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/aria-role */
import React, { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import Layout from "../../components/Layout";
import CreateIntroduction from "../../pages/introduction/CreateIntroduction/CreateIntroduction";
// import FriendsIntroduction from "../../pages/friendIntroduction/friendForm";

// import IntroductionRemarks from "../../pages/introductionRemarks";
import MarkAttendance from "../../pages/markAttendance";

// import IntroductionRemarks from "../../pages/introductionRemarks";
import TransferFriend from "../../pages/friend/FriendTransferRequest/FriendTransferRequest";
import { ROUTES } from "../../utils/constants";

// pages
import ApplyAppointment from "../../pages/appointment/ApplyAppointment/ApplyAppointment";
import CreateNewFamilyForm from "../../pages/family/CreateNewFamily/CreateNewFamily";
import EditFamily from "../../pages/family/EditFamilyMember/EditFamilyMember";
import FamilyDetail from "../../pages/family/FamilyDetails/FamilyDetails";
import FamilyDetailsList from "../../pages/family/FamilyDetailsList/FamilyDetailsList";
import FriendsDetail from "../../pages/friend/friendDetails/FriendDetails";
import FriendTransfer from "../../pages/friend/FriendPending/FriendPending";
import FriendTransferForm from "../../pages/friend/FriendPending/FriendPendingForm/FriendPendingForm";
// import FriendSearch from "../../pages/friend/FriendSearch/FriendSearch";
import FriendSearch from "../../pages/friend/FriendSearch/SearchFriend";
import SearchNewFriend from "../../pages/friend/NewFriend";
import ChangeToNewFriend from "../../pages/friend/NewFriend/ChangeToNewFriend/ChangeToNewFriend";
import CreateNewFriend from "../../pages/friend/NewFriend/CreateNewFriend/CreateNewFriend";
import ApplyGohonzon from "../../pages/gohonzon/ApplyGohonzon/ApplyGohonzon";
import GohonzonSubmission from "../../pages/gohonzon/GohonzonSubmission/GohonzonSubmission";
import Help from "../../pages/Help";
import IntroductionPending from "../../pages/introduction/introductionPending";
import ViewIntroduction from "../../pages/introduction/viewIntroduction/ViewIntroduction";
import Attendance from "../../pages/markAttendance/Attendance";
import MemberCreate from "../../pages/member/MemberCreate/MemberCreate";
import MembersDetail from "../../pages/member/memberDetails";
import MemberFamilyDetails from "../../pages/member/MemberFamilyDetails";
import MemberPending from "../../pages/member/MemberPending/memberPending";
import MemberProfileEdit from "../../pages/member/MemberProfileEdit/MemberProfileEdit";
import MemberSearchForm from "../../pages/member/MemberSearch/MemberSearch";
import MemberTransferRequest from "../../pages/member/MemberTransferRequest/MemberTransferRequest";
import MemberTransferForm from "../../pages/member/MemberTransferTo/MemberTransferTo";
import Remarks from "../../pages/Remarks";
import CommitteeParticipate from "../../components/AppointmentModals/FeedBack/CommiteeParticipateModal";
import MarkLoginModal from "../../components/AppointmentModals/FeedBack/MarkLogin/MarkLoginModal";
import { APPOINTMENT_TABLES_MAP } from "../../contants/appointment";
import { GOHONZON_TABLES_MAP } from "../../contants/gohonzon";
import AppointmentSubmission from "../../pages/appointment/AppointmentSubmission/AppointmentSubmission";
import SplitApply from "../../pages/appointment/Split/SplitApply/SplitApply";
import ViewAnnouncement from "../../pages/Announcement/ViewAnnouncement/ViewAnnouncement";
import ViewOrganogram from "../../pages/appointment/Split/ViewOrganogram/ViewOrganogram";
import FriendProfileForm from "../../pages/friend/friendProfileForm/FriendProfileForm";
import RoleManagement from "../../pages/UserManagement/UserRoleManagement";
import PermissionManagement from "../../pages/UserManagement/PermissionManagement";
import DirectAppointment from "../../pages/appointment/DirectAppointment/DirectAppointment/DirectAppointment";
import AdhocAppointment from "../../pages/appointment/DirectAppointment/DirectAppointment/AdhocAppointment";
import FutureDivision from "../../pages/appointment/DirectAppointment/DirectAppointment/FutureDivisionApply";
import Student from "../../pages/appointment/DirectAppointment/DirectAppointment/StudentApply";
import UHG from "../../pages/appointment/DirectAppointment/DirectAppointment/UHGApply";
import Dashboard from "../../pages/Dashboard/Dashboard";
import NationalAppointment from "../../pages/appointment/DirectAppointment/DirectAppointment/NationalAppointment";
import GohonzonInventory from "../../pages/gohonzon/GohonzonInventory/GohonzonInventory";
import HandoverInventory from "../../pages/gohonzon/GohonzonInventory/GohonzonTable/HandoverInventory";
import MasterInventory from "../../pages/gohonzon/GohonzonInventory/GohonzonTable/MasterInventory";
import MemberReportSearch from "../../pages/Reports/MembersReports/MemberReportsSearch";
import FriendReportSearch from "../../pages/Reports/FriendsReports/FriendReportsSearch";
import FriendDeactivateReport from "../../pages/Reports/FriendsReports/FriendDeactivateReport";
import FriendChangedToMemberReports from "../../pages/Reports/FriendsReports/FriendChangedToMemberReports";
import AttendanceReportsSearch from "../../pages/Reports/AttendanceReports/AttendanceReportsSeach";
import DownloadReports from "../../pages/Reports/DownloadReports/DownloadReports";
import Editor from "../../pages/Emailer/Editor/Editor";
import EmailerRecipients from "../../pages/Emailer/EmailerRecipients/EmailerRecipients";
import SplitNewStructure from "../../pages/appointment/Split/SplitNewStructure/SplitNewStructure";
import BulkTransfer from "../../pages/appointment/Split/BulkTransfer/BulkTransfer";
import UniversityList from "../../pages/UniversityList/UniversityList";
import NewMemberCreate from "../../pages/member/MemberCreate/NewMemberCreate";
import FriendTransferRequest from "../../pages/friend/FriendTransferRequest/TransferRequest";
import IntroductionTransferRequest from "../../pages/introduction/introductionPending/TransferRequest";
import MemberRequest from "../../pages/member/MemberTransferRequest/TransferRequest";
import InductionSearch from "../../pages/Graduation/InductionSearch";
import GraduationSearch from "../../pages/Graduation/GraduationSearch";
import DivisionSearch from "../../pages/Graduation/DivisionGraduationSearch";
import ViewRecipients from "../../pages/Emailer/ViewRecipients";
import TemplateList from "../../pages/Emailer/TemplateList/TemplateList";
import DeactivationVerification from "../../pages/member/MemberDeactivation";
import GohonzonConferralReport from "../../pages/Reports/GohonzonReports/GohonzonConferralReports";
import GohonzonAllotmentReport from "../../pages/Reports/GohonzonReports/GohonzonAllotmentReports";
import StrucutreAttendanceReportsSearch from "../../pages/Reports/AttendanceReports/StructureLevelAttendanceReport";
import UnmarkedAttendanceReportSearch from "../../pages/Reports/AttendanceReports/UnMarkedAttendance";
import ViewArchiveAttendance from "../../pages/markAttendance/ArchiveAttendance/ArchiveAttendance";
import ArchiveAttendance from "../../pages/markAttendance/ArchiveAttendance/Attendance";
import StatsReport from "../../pages/Reports/StatsReports/StatsReports";
import Organogram from "../../pages/appointment/Split/ViewOrganogram/Organogram";
// import AppointmentTrackingList from "../../pages/appointment/AppointmentTracking/AppointmentTrackingList";
import GohonzonConsentUrl from "../../pages/gohonzon/GohonzonConsentUrl/GohonzonConsentUrl";
import EmailUpdate from "../../pages/Emailer/EmailUpdate/EmailUpdate";
import NewViewOrganogram from "../../pages/appointment/Split/ViewOrganogram/NewViewOrganogram";
import ControlPanel from "../../pages/UserManagement/ControlPanel";
// import MemberReactivation from "../../pages/member/components/MemberReactivation/MemberReactivation";
import SubscriptionReport from "../../pages/Reports/SubscriptionReports/SubscriptionReports";
import FilesList from "../../pages/HandleFiles/GetFiles";
import NationalSpecialGroup from "../../pages/appointment/DirectAppointment/DirectAppointment/NationalSpecialGroup";
import ExaminationMemberSearch from "../../pages/Examination/MemberSearch/Index";
import AppliedMemberSearch from "../../pages/Examination/MemberSearch/AppliedMembers";
import ResultMembersSearch from "../../pages/Examination/MemberSearch/ResultMembers";
import CreateTicket from "../../pages/TicketSystem/CreateTicket/CreateTicket";
import TicketList from "../../pages/TicketSystem/TicketList/TicketList";
import MembersDetailForMobile from "../../pages/member/memberDetails/MemberDetailsForMobile";
import FriendSummaryReports from "../../pages/Reports/FriendsReports/FriendSummary/FriendSummaryReports";
import FriendAgeingReports from "../../pages/Reports/FriendsReports/FriendAgeing/FriendAgeing";
import SubscriptionTrendsReports from "../../pages/Reports/SubscriptionReports/SubscriptionTrendsReports";
import SubscriptionMisReport from "../../pages/Reports/SubscriptionReports/SubscriptionMisReport";
import ExpiredSubscriptionReports from "../../pages/Reports/SubscriptionReports/ExpiredSubscriptionReports";
import NearToExpirySubscriptionReports from "../../pages/Reports/SubscriptionReports/NearToExpirySubscriptionReports";
import FriendToMemberTrends from "../../pages/Reports/FriendsReports/FriendToMemberTrend/FriendToMemberTrend";
import FriendToMemberGrowth from "../../pages/Reports/FriendsReports/FriendToMemberGrowth/FriendToMemberGrowth";
import NewFriendTrends from "../../pages/Reports/FriendsReports/NewFriendTrend/NewFriendTrend";
import IpConfigManagement from "../../pages/UserManagement/IpConfigManagement";
import ExamReportData from "../../pages/Examination/MemberSearch/ExamReportData";
import ForceLogout from "../../pages/UserManagement/ForceLogout/ForceLogout";

function DashboardComp() {
  const navigate = useNavigate();
  useEffect(() => {
    ReactGA.initialize("G-12HXXCR4Y4");
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
    });
    // ReactGA.pageview(window.location.pathname);
    return navigate((location) => {
      ReactGA.set({ page: location.pathname });
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname,
      });
      // ReactGA.pageview(location.pathname);
    });
  }, [navigate]);
  useEffect(() => {
    ReactGA.initialize("G-12HXXCR4Y4");
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-12HXXCR4Y4";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [navigate]);

  return (
    <div className="main-container">
      <Routes>
        <Route path={ROUTES.HOME.path} element={<Layout />}>
          <Route exact index path={ROUTES.HOME.path} element={<Dashboard />} />
          <Route
            exact
            index
            path={ROUTES.CREATE_INTRODUCTION.path}
            element={<CreateIntroduction />}
          />
          {/* <Route
            exact
            index
            path={ROUTES.VIEW_INTRODUCTION.path}
            element={<TransferForm />}
          /> */}
          {/* <Route
          index
          path={ROUTES.FRIENDS_INTRODUCTION.path}
          element={<FriendsIntroduction />}
        /> */}
          <Route
            exact
            path={ROUTES.INTRODUCTION_VIEW.path}
            element={<ViewIntroduction />}
          />
          <Route
            exact
            path={ROUTES.INTRODUCTION_TRANSFER_REQUEST.path}
            element={<IntroductionTransferRequest />}
          />
          {/* <Route
          path={ROUTES.INTRODUCTION_PENDING_TO_DISTRICT.path}
          element={<IntroductionPending />}
        /> */}
          <Route
            exact
            path={ROUTES.FRIEND_SEARCH.path}
            element={<FriendSearch />}
          />
          <Route
            exact
            path={`${ROUTES.FRIEND_PENDING_TRANSFER.path}/:type`}
            element={<FriendTransfer />}
          />
          <Route
            exact
            path={ROUTES.FRIEND_TRANSFER_FORM.path}
            element={<FriendTransferForm />}
          />
          <Route
            exact
            path={`${ROUTES.FRIEND_DETAIL.path}/:id`}
            element={<FriendsDetail />}
          />
          <Route
            exact
            path={`${ROUTES.FRIEND_EDIT_PROFILE.path}/:id`}
            element={<FriendProfileForm />}
          />
          <Route
            exact
            path={ROUTES.INTRODUCTION_PENDING.path}
            element={<IntroductionPending />}
          />
          <Route
            exact
            path={ROUTES.FRIEND_TRANSFER.path}
            element={<TransferFriend />}
          />
          <Route
            exact
            path={ROUTES.FRIEND_TRANSFER_REQUEST.path}
            element={<FriendTransferRequest />}
          />
          <Route
            exact
            path={`${ROUTES.MEMBER_DETAIL.path}/:id`}
            element={<MembersDetail />}
          />
          <Route
            exact
            path={`${ROUTES.MEMBER_DETAIL_FOR_MOBILE.path}/:id`}
            element={<MembersDetailForMobile />}
          />
          <Route
            exact
            index
            path={ROUTES.MEMBER_FAMILY_DETAIL.path}
            element={<MemberFamilyDetails />}
          />
          <Route
            exact
            path={ROUTES.MEMBER_SEARCH.path}
            element={<MemberSearchForm />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_MEMBER.path}
            element={<MemberReportSearch />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_FRIEND.path}
            element={<FriendReportSearch />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_DEACTIVATED_FRIEND.path}
            element={<FriendDeactivateReport />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_CHANGED_TO_MEMBER.path}
            element={<FriendChangedToMemberReports />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_FRIEND_SUMMARY.path}
            element={<FriendSummaryReports />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_FRIEND_AGEING.path}
            element={<FriendAgeingReports />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_ATTENDANCE.path}
            element={<AttendanceReportsSearch />}
          />
          <Route
            exact
            path={ROUTES.STRUCTURE_ATTENDANCE_REPORT.path}
            element={<StrucutreAttendanceReportsSearch />}
          />
          <Route
            exact
            path={ROUTES.UNMARKED_ATTENDANCE_REPORT.path}
            element={<UnmarkedAttendanceReportSearch />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_GOHONZON_CONFERRAL.path}
            element={<GohonzonConferralReport />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_GOHONZON_ALLOTMENT.path}
            element={<GohonzonAllotmentReport />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_CURRENT_STATS.path}
            element={<StatsReport />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_SUBSCRIPTION.path}
            element={<SubscriptionReport />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_SUBSCRIPTION_TRENDS.path}
            element={<SubscriptionTrendsReports />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_SUBSCRIPTION_MIS.path}
            element={<SubscriptionMisReport />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_EXPIRED_SUBSCRIPTION.path}
            element={<ExpiredSubscriptionReports />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_NEAR_TO_EXPIRY_SUBSCRIPTION.path}
            element={<NearToExpirySubscriptionReports />}
          />
          <Route
            exact
            path={ROUTES.DOWNLOAD_REPORTS.path}
            element={<DownloadReports />}
          />
          <Route exact path={ROUTES.EMAILER_EDITOR.path} element={<Editor />} />
          <Route
            exact
            path={ROUTES.EMAILER_TEMPLATES.path}
            element={<TemplateList />}
          />
          <Route
            exact
            path={`${ROUTES.EMAILER_UPDATE.path}/:id`}
            element={<EmailUpdate />}
          />
          <Route
            exact
            path={ROUTES.EMAILER_RECIPIENTS.path}
            element={<EmailerRecipients />}
          />
          <Route
            exact
            path={`${ROUTES.VIEW_RECIPIENTS.path}/:id`}
            element={<ViewRecipients />}
          />
          <Route exact path={ROUTES.FILES_LIST.path} element={<FilesList />} />
          <Route
            exact
            path={ROUTES.MARK_ATTENDANCE.path}
            element={<Attendance />}
          />
          <Route
            exact
            path={ROUTES.ARCHIVE_MARK_ATTENDANCE.path}
            element={<ArchiveAttendance />}
          />
          <Route
            exact
            path={ROUTES.MEMBER_TRANSFER.path}
            element={<MemberTransferRequest />}
          />
          <Route
            exact
            path={ROUTES.ATTENDANCE.path}
            element={<MarkAttendance />}
          />
          <Route
            exact
            path={ROUTES.ARCHIVE_ATTENDANCE.path}
            element={<ViewArchiveAttendance />}
          />
          <Route
            exact
            path={ROUTES.NEW_FRIEND_SEARCH.path}
            element={<SearchNewFriend />}
          />
          <Route
            exact
            path={ROUTES.CREATE_NEW_FRIEND.path}
            element={<CreateNewFriend />}
          />
          <Route
            exact
            path={ROUTES.CHANGE_TO_FRIEND_SEARCH.path}
            element={<ChangeToNewFriend />}
          />
          <Route
            exact
            path={ROUTES.FAMILY_DETAILS.path}
            element={<FamilyDetail />}
          />
          <Route
            exact
            path={ROUTES.FAMILY_DETAIL.path}
            element={<FamilyDetailsList />}
          />
          <Route
            exact
            path={`${ROUTES.EDIT_FAMILY_MEMBER.path}/:id`}
            element={<EditFamily />}
          />
          <Route
            exact
            path={`${ROUTES.VIEW_FAMILY_DETAIL.path}/:id/:preview`}
            element={<EditFamily />}
          />
          <Route
            exact
            path={ROUTES.CREATE_NEW_FAMILY.path}
            element={<CreateNewFamilyForm />}
          />
          <Route
            exact
            path={ROUTES.UNIVERSITY_LIST.path}
            element={<UniversityList />}
          />
          <Route
            exact
            path={ROUTES.SG_INDUCTION.path}
            element={<InductionSearch />}
          />
          <Route
            exact
            path={ROUTES.SG_GRADUATION.path}
            element={<GraduationSearch />}
          />
          <Route
            exact
            path={ROUTES.SG_DIVISION.path}
            element={<DivisionSearch />}
          />
          <Route
            exact
            index
            path={ROUTES.EXAMINATIONS.path}
            element={<Help />}
          />
          <Route
            exact
            path={ROUTES.TICKET_CREATE.path}
            element={<CreateTicket />}
          />
          <Route
            exact
            path={ROUTES.TICKET_LIST.path}
            element={<TicketList />}
          />
          <Route
            exact
            index
            path={ROUTES.APPLY_GOHONZON.path}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.GOHONZON_APPLY} />
            }
          />
          <Route
            exact
            path={ROUTES.APPLICATION_VERIFICATION.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.APPLICATION_VERIFICATION}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_RETURN_VERIFICATION.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_RETURN_VERIFICATION}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_REPLACEMENT_VERIFICATION.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_REPLACEMENT_VERIFICATION}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_INTERVIEW.path}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.GOHONZON_INTERVIEW} />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_APPLICATIONS.path}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.GOHONZON_APPLICATIONS} />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_VERIFICATION.path}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.GOHONZON_VERIFICATION} />
            }
          />
          <Route
            exact
            path={`${ROUTES.GOHONZON_RETURN_VERIFICATION.path}/:batchId`}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_RETURN_VERIFICATION}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_BATCH_ALLOTMENT.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_BATCH_ALLOTMENT}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_BATCH_HISTORY.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_BATCH_HISTORY}
              />
            }
          />
          <Route
            exact
            path={`${ROUTES.GOHONZON_ALLOTMENT.path}/:batchId`}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.GOHONZON_ALLOTMENT} />
            }
          />
          <Route
            exact
            path={`${ROUTES.GOHONZON_BATCH_VIEW.path}/:batchId`}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.GOHONZON_BATCH_VIEW} />
            }
          />
          <Route
            exact
            path={ROUTES.ALLOTMENT_HISTORY.path}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.ALLOTMENT_HISTORY} />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_HANDOVER.path}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.GOHONZON_HANDOVER} />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_BATCH_CONFERRAL.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_BATCH_CONFERRAL}
              />
            }
          />
          <Route
            exact
            path={`${ROUTES.GOHONZON_CONFERRAL.path}/:batchId`}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.GOHONZON_CONFERRAL} />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_OMAMORI_CONFERRAL.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_CONFERRAL}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_REPLACEMENT_CONFERRAL.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_REPLACEMENT_CONFERRAL}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_CANCELLATION.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_CANCEL_REQUEST}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_RETURNED_HANDOVER.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_RETURNED_HANDOVER}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_RETURN.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_RETURN_REQUEST}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_OMAMORI_ALLOTMENT.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_ALLOTMENT}
              />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_OMAMORI_HANDOVER.path}
            element={
              <ApplyGohonzon
                type={GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_HANDOVER}
              />
            }
          />
          <Route
            exact
            index
            path={`${ROUTES.GOHOZON_SUBMISSION.path}/:type/:preview`}
            element={<GohonzonSubmission />}
          />
          <Route
            exact
            index
            path={`${ROUTES.GOHOZON_SUBMISSION.path}/:type/:preview`}
            element={<GohonzonSubmission />}
          />
          <Route
            exact
            index
            path={`${ROUTES.GOHOZON_SUBMISSION.path}/:type`}
            element={<GohonzonSubmission />}
          />

          <Route
            exact
            index
            path={ROUTES.APPOINTMENT_FEEDBACK_MODAL.path}
            element={<CommitteeParticipate />}
          />
          <Route
            exact
            index
            path={ROUTES.APPOINTMENT_MARK_LOGIN_MODAL.path}
            element={<MarkLoginModal />}
          />
          <Route
            exact
            path={ROUTES.GOHONZON_APPROVAL.path}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.GOHONZON_APPROVAL} />
            }
          />
          <Route
            exact
            path={ROUTES.GOHONZON_TRACKING.path}
            element={
              <ApplyGohonzon type={GOHONZON_TABLES_MAP.GOHONZON_TRACKING} />
            }
          />
          <Route
            exact
            index
            path={ROUTES.GOHOZON_SUBMISSION.path}
            element={<GohonzonSubmission />}
          />
          <Route
            exact
            index
            path={ROUTES.GOHONZON_INVENTORY.path}
            element={<GohonzonInventory />}
          />
          <Route
            exact
            index
            path={ROUTES.HANDOVER_INVENTORY.path}
            element={<HandoverInventory />}
          />
          <Route
            exact
            index
            path={ROUTES.MASTER_INVENTORY.path}
            element={<MasterInventory />}
          />
          <Route
            exact
            index
            path={ROUTES.GOHONZON_CONSENT_URL.path}
            element={<GohonzonConsentUrl />}
          />
          <Route
            exact
            index
            path={ROUTES.APPLY_APPOINTMENT.path}
            element={
              <ApplyAppointment
                type={APPOINTMENT_TABLES_MAP.APPOINTMENT_APPLY}
              />
            }
          />
          <Route
            exact
            index
            path={ROUTES.NEW_STRUCTURE_APPLY.path}
            element={<SplitApply />}
          />
          <Route
            exact
            index
            path={`${ROUTES.NEW_STRUCTURE_APPLY_CREATE.path}/:level/:parentId`}
            element={<SplitNewStructure />}
          />
          <Route
            exact
            index
            path={ROUTES.NEW_STRUCTURE_BULK_TRANSFER.path}
            element={<BulkTransfer />}
          />
          <Route
            exact
            index
            path={ROUTES.NEW_STRUCTURE_VIEW_ORGANOGRAM.path}
            element={<Organogram />}
          />
          <Route
            exact
            index
            path={`${ROUTES.NEW_STRUCTURE_CHART.path}/:id`}
            element={<ViewOrganogram />}
          />
          <Route
            exact
            index
            path={`${ROUTES.NEW_VIEW_ORGANOGRAM_CHART.path}/:id`}
            element={<NewViewOrganogram />}
          />
          <Route
            exact
            path={ROUTES.APPOINTMENT_REVIEW.path}
            element={
              <ApplyAppointment
                type={APPOINTMENT_TABLES_MAP.APPOINTMENT_REVIEW}
              />
            }
          />
          <Route
            exact
            path={ROUTES.APPOINTMENT_TRACKING.path}
            element={
              <ApplyAppointment
                type={APPOINTMENT_TABLES_MAP.APPOINTMENT_TRACKING}
              />
            }
          />
          {/* <Route
            exact
            path={ROUTES.APPOINTMENT_TRACKING.path}
            element={<AppointmentTrackingList />}
          /> */}
          <Route
            exact
            path={ROUTES.REVIEW_APPOINTMENT.path}
            element={
              <ApplyAppointment
                type={APPOINTMENT_TABLES_MAP.REVIEW_APPOINTMENT}
              />
            }
          />
          <Route
            exact
            path={ROUTES.PARTIAL_REVIEW_APPOINTMENT.path}
            element={
              <ApplyAppointment
                type={APPOINTMENT_TABLES_MAP.PARTIAL_REVIEW_APPOINTMENT}
              />
            }
          />
          <Route
            exact
            path={ROUTES.PARTIAL_APPROVED_APPOINTMENT.path}
            element={
              <ApplyAppointment
                type={APPOINTMENT_TABLES_MAP.PARTIAL_APPROVED_APPOINTMENT}
              />
            }
          />
          <Route
            exact
            path={ROUTES.APPOINTMENT_PROPOSE_APPLICATION.path}
            element={
              <ApplyAppointment
                type={APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_APPLICATION}
              />
            }
          />
          <Route
            exact
            path={ROUTES.APPOINTMENT_SECOND_APPROVAL_APPLICATION.path}
            element={
              <ApplyAppointment
                type={
                  APPOINTMENT_TABLES_MAP.APPOINTMENT_SECOND_APPROVAL_APPLICATION
                }
              />
            }
          />
          <Route
            exact
            path={ROUTES.APPOINTMENT_PROPOSE_MARK_APPLICATION.path}
            element={
              <ApplyAppointment
                type={
                  APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_MARK_APPLICATION
                }
              />
            }
          />
          <Route
            exact
            path={ROUTES.APPOINTMENT_SUBMISSION.path}
            element={<AppointmentSubmission />}
          />
          <Route
            exact
            index
            path={`${ROUTES.APPOINTMENT_SUBMISSION.path}/:type`}
            element={<AppointmentSubmission />}
          />
          <Route
            exact
            index
            path={ROUTES.APPOINTMENT_DIRECT.path}
            element={<DirectAppointment />}
          />
          <Route
            exact
            index
            path={ROUTES.APPOINTMENT_ADHOC.path}
            element={<AdhocAppointment />}
          />
          <Route
            exact
            index
            path={ROUTES.APPOINTMENT_FUTURE_DIVISION.path}
            element={<FutureDivision />}
          />
          <Route
            exact
            index
            path={ROUTES.APPOINTMENT_STUDENT.path}
            element={<Student />}
          />
          <Route
            exact
            index
            path={ROUTES.APPOINTMENT_UHG.path}
            element={<UHG />}
          />
          <Route
            exact
            index
            path={ROUTES.NATIONAL_APPOINTMENT.path}
            element={<NationalAppointment />}
          />
          <Route
            exact
            index
            path={ROUTES.NATIONAL_SPECIAL_APPOINTMENT.path}
            element={<NationalSpecialGroup />}
          />
          <Route
            exact
            path={ROUTES.VIEW_ANNOUNCEMENT.path}
            element={<ViewAnnouncement />}
          />
          <Route
            exact
            path={ROUTES.USER_MANAGEMENT_MEMBER_SEARCH.path}
            element={<RoleManagement />}
          />
          <Route
            exact
            path={ROUTES.USER_IP_CONFIG_MANAGEMENT.path}
            element={<IpConfigManagement />}
          />
          <Route
            exact
            path={ROUTES.USER_PERMISSION_MANAGEMENT.path}
            element={<PermissionManagement />}
          />
          <Route
            exact
            path={ROUTES.FORCE_LOGOUT.path}
            element={<ForceLogout />}
          />
          <Route
            exact
            index
            path={ROUTES.ORGANIZATION_STRUCTURE.path}
            element={<Help />}
          />
          {/* <Route exact index path={ROUTES.HELP_PAGE.path} element={<Help />} /> */}
          <Route exact path={ROUTES.REMARKS.path} element={<Remarks />} />
          <Route
            exact
            path={ROUTES.MEMBER_TRANSFER_REQUEST.path}
            element={<MemberTransferForm />}
          />
          <Route
            exact
            path={ROUTES.NEW_MEMBER.path}
            element={<MemberCreate />}
          />
          <Route
            exact
            path={ROUTES.NEW_MEMBER_CREATE.path}
            element={<NewMemberCreate />}
          />
          {/* <Route
            exact
            path={ROUTES.MEMBER_REACTIVATION.path}
            element={<MemberReactivation />}
          /> */}
          <Route
            exact
            path={ROUTES.MEMBER_DEACTIVATION.path}
            element={<DeactivationVerification />}
          />
          <Route
            exact
            path={`${ROUTES.MEMBER_EDIT_PROFILE.path}/:id`}
            element={<MemberProfileEdit />}
          />
          <Route
            exact
            path={`${ROUTES.MEMBER_PENDING_TRANSFER.path}/:type`}
            element={<MemberPending />}
          />
          <Route
            exact
            path={ROUTES.MEMBER_REQUEST.path}
            element={<MemberRequest />}
          />
          <Route
            exact
            path={ROUTES.CONTROL_PANEL.path}
            element={<ControlPanel />}
          />
          <Route
            exact
            path={ROUTES.EXAMINATION_MEMBER_SEARCH.path}
            element={<ExaminationMemberSearch />}
          />
          <Route
            exact
            path={ROUTES.APPLIED_MEMBER_SEARCH.path}
            element={<AppliedMemberSearch />}
          />
          <Route
            exact
            path={ROUTES.RESULT_MEMBER_SEARCH.path}
            element={<ResultMembersSearch />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_FRIEND_CHANGED_TO_MEMBER_TRENDS.path}
            element={<FriendToMemberTrends />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_FRIEND_TO_MEMBER_GROWTH.path}
            element={<FriendToMemberGrowth />}
          />
          <Route
            exact
            path={ROUTES.REPORTS_NEW_FRIEND_TRENDS.path}
            element={<NewFriendTrends />}
          />
        </Route>

        <Route
          path="*"
          element={<Navigate to="/introduction/create" replace />}
        />
        <Route exact index path={ROUTES.IN.path} element={<ExamReportData />} />
      </Routes>
    </div>
  );
}

export default function LoggedInRoutes() {
  return <DashboardComp />;
}
